import {
    FAILED_TO_GET_SOLICITOR_HOME_PAGE_INFO, GET_SOLICITOR_HOME_PAGE_INFO, LOGOUT,
    RECEIVE_SOLICITOR_HOME_PAGE_INFO
} from "../actions/index";

const defaultState = {
    fetching: false,
    information: []
};

export default (state = defaultState, action) => {
    switch (action.type) {
        case GET_SOLICITOR_HOME_PAGE_INFO:
            return {
                ...state,
                fetching: true
            };
        case RECEIVE_SOLICITOR_HOME_PAGE_INFO:
            return {
                ...state,
                fetching: false,
                information: action.payload
            };
        case FAILED_TO_GET_SOLICITOR_HOME_PAGE_INFO:
            return {
                ...state,
                fetching: false
            };
        case LOGOUT:
            return {
                ...defaultState
            };
        default:
            return state
    }
}